import { ContextualBarAPI, FormAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService, LanguageService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import moment from 'moment';
import { FragmentNames, MyChartMedicineHospitalDetailAliases } from '../../codegen';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import UserContext from '../../utils/user-context';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { InformDose } from '../my-chart-medicine-patient/my-chart-medicine-patient-controller';
import './my-chart-medicine-hospital-detail.css';

@Controller({ fragment: FragmentNames.MY_CHART_MEDICINE_HOSPITAL_DETAIL })
class MyChartMedicineHospitalDetailController extends BaseController {

  @Inject(MyChartMedicineHospitalDetailAliases.FORM_MEDICINE_HOSPITAL)
    medicineHospitalFormApi!: FormAPI;

  @Inject(MyChartMedicineHospitalDetailAliases.CONTEXTUAL_BAR_MEDICINE_HOSPITAL_DETAIL)
    medicineHospitalContextualBarApi!: ContextualBarAPI;

  @OnMount(MyChartMedicineHospitalDetailAliases.FORM_MEDICINE_HOSPITAL)
  handleMountMedicineForm(event: MountEvent): void {
    const medicineHospitalFormApi = event.target as FormAPI;
    const medicineSequence = this.getHistoryRouteParam<Value>('medicineSequence');

    const title = `${MessageService.translate('patient.label.medicine-detail')} - ${MessageService.translate('patient.my-chart.label.hospital')}`;
    this.medicineHospitalContextualBarApi.setTitle(title);

    HttpService.get(APPLICATION_ENDPOINTS.GET_MC_MEDICINE_HOSPITAL_DETAIL, { medicamentSequence: medicineSequence, patientId: UserContext.patientId })
      .then(response => response.body as Record<string, Value>)
      .then(data => {

        const localeStr = LanguageService.getCurrentLanguage().replace('_', '-');
        const startDate = data.startDate as string;
        const endDate = data.endDate as string;
        data.startDate = startDate ? moment(startDate).locale(localeStr).format('L') : '';
        data.endDate = endDate ? moment(endDate).locale(localeStr).format('L') : '';
        data.notes = data.notes || '-';
        data.unitMeasurement = data.unitMeasurement || '-';
        data.interval = data.interval || '-';
        data.dose = data.dose || '-';
        data.dontKnowTheDose = data.dontKnowTheDose?.toString() === InformDose.NOT_INFORMED_DOSE ? MessageService.translate('patient.moda.button-yes') : MessageService.translate('patient.modal.button-cancel');

        medicineHospitalFormApi.setData(data);
      });
  }

}
export default MyChartMedicineHospitalDetailController;
